var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{attrs:{"id":_vm.id,"type":"email","name":_vm.name,"required":_vm.required,"value":_vm.value,"label":_vm.label},on:{"input":function (val) { return this$1.$emit('input', val); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }